import GatsbyImageOriginal from 'gatsby-image';
import T from 'prop-types';
import React from 'react';

import Image from '@skippay/core/components/Image';

function GatsbyImage(props) {
	const {
		childImageSharp: { id, ...gqlResult },
		prioritize,
		...other
	} = props;

	return (
		<Image
			{...other}
			gatsby={
				<GatsbyImageOriginal
					{...gqlResult}
					{...(prioritize && { loading: 'eager' })}
					alt={props.alt}
				/>
			}
		/>
	);
}

GatsbyImage.propTypes = {
	...Image.propTypes,
	childImageSharp: T.oneOfType([
		T.shape({ fixed: T.object.isRequired }),
		T.shape({ fluid: T.object.isRequired }),
	]).isRequired,
	prioritize: T.bool,
	maxWidth: T.number,
};

export default GatsbyImage;
